const Tag = ({ label, ...property }) => (
  <button onClick={property.onClick} className={` rounded-full ${property.className}  text-${property.size} font-${property.weight} `}> <p className="mb-1">{label}</p>  </button>
);
export default Tag;
